<template>
	<div class="imovel-cadastro-dialog">
		<Dialog class="test-box" :header="headerDialog" :visible.sync="showRemoverImovel" :modal="true" :closable="false">
			<div class="container">
				<div class="row">
					<div class="col-md-12 mb-2 mensagem-cancelamento">
						<p>
							{{
								"O Imovel" +
								" " +
								(this.imovel ? this.imovel.detail : "") +
								" será removido."
							}}
						</p>
						<p>
							{{ "Deseja continuar?" }}
						</p>
					</div>
				</div>
			</div>

			<hr />

			<div class="botoes-avancar-voltar">
				<Button @click="removerImovel()" href="#topo" type="button" label="Remover"
					class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />

				<Button @click="showRemoverImovel = false" type="button" label="Fechar"
					class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
			</div>
		</Dialog>
		<Dialog class="imovel-modal" :visible.sync="showCadastroImovel" :modal="true" :closable="false">
			<h1 class="titulo-header">
				{{ headerDialog }}
				<Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
					@click="showCadastroTomador = false" />
			</h1>
			<div id="topo" class="scrolable-dialog">
				<error-list :erros="erros" />
				<div class="card-body">
					<form name="form" @submit.prevent="onSubmit">
						<div class="row d-flex align-items-end">

							<div class="col-md-2 mb-2">
								<label>Inscrição Imobiliária: </label>
								<span class="p-fluid">
									<InputText type="text" maxlength="30" v-model="imovel.inscImobiliaria"></InputText>
								</span>
							</div>

							<div class="col-md-2 mb-2">
								<label>Código CIB: </label>
								<span class="p-fluid">
									<InputText type="text" v-model="imovel.codigoCib" maxlength="8"></InputText>
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-8 mb-2">
								<label for="nome">Descrição Imóvel: *</label>
								<span class="p-fluid">
									<InputText type="text" id="nome" v-model="imovel.descricao" maxlength="500"/>
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3 mb-2">
								<label for="cep">CEP: *</label>
								<span class="p-fluid">
									<div class="p-inputgroup">
										<InputMask v-model="imovel.cep" mask="99.999-999" placeholder="Pesquisar" />
									</div>
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-10 mb-2">
								<label for="enderecoImovel">Endereço Imóvel: *</label>
								<span class="p-fluid">
									<textarea id="enderecoImovel" name="enderecoImovel" v-model="imovel.endereco"
										rows="5" maxlength="255" />
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-2 mb-2">
								<label>Número: *</label>
								<span class="p-fluid">
									<InputText type="text" maxlength="60" v-model="imovel.numero"></InputText>
								</span>
							</div>
							<div class="col-md-2 mb-2">
								<label>Bairro: *</label>
								<span class="p-fluid">
									<InputText type="text" maxlength="60" v-model="imovel.bairro"></InputText>
								</span>
							</div>
							<div class="col-md-2 mb-2">
								<label>Complemento: </label>
								<span class="p-fluid">
									<InputText type="text" maxlength="156" v-model="imovel.complemento"></InputText>
								</span>
							</div>
						</div>

						<hr />
						<div class="botoes-avancar-voltar">
							<Button @click="salvar()" href="#topo" type="button" label="Gravar"
								class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
							<Button @click="showCadastroImovel = false" type="button" label="Fechar"
								class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
						</div>
					</form>
				</div>
			</div>
		</Dialog>
	</div>
</template>

<script>
import money from "../conf/config.money";
import Imovel from '../models/imovel/Imovel';
import LoginService from "../services/acesso/login.service";
import ImovelService from '../services/nfse/imovel.service';

export default {
	name: 'ImovelCadastroDialog',
	data() {
		return {
			erros: [],
			modoEdicao: false,
			showCadastroImovel: false,
			showRemoverImovel: false,
			loading: false,
			money: money,
			filtro: "",
			filteredTipoImovel: null,
			selectedTipoImovel: null,
			filteredTipoDesconto: null,
			selectedTipoDesconto: null,
			imovel: new Imovel(),
		}
	},
	created() {
		this.$root.$on("notaFiscal:novoImovel", () => {
			this.limparForm();
			this.modoEdicao = false;
			this.showCadastroImovel = true;
			this.showRemoverImovel = false;
		});
		this.$root.$on("notaFiscal:editarImovel", () => {
			this.imovel = this.$parent.selectedImovel;
			this.modoEdicao = true;
			this.showCadastroImovel = true;
			this.showRemoverImovel = false;
		});
		this.$root.$on("notaFiscal:removerImovel", () => {
			this.imovel = this.$parent.selectedImovel;
			this.showCadastroImovel = false;
			this.showRemoverImovel = true;
		});

		this.currentUser = LoginService.currentUserValue;

	},

	methods: {

		salvar() {
			this.processando(true);
			this.imovel.idCliente = this.currentUser.usuario.idCliente;
			this.imovel.idContribuinteCadastro = this.currentUser.contribuinte.idContribuinte;

			ImovelService.saveImovel(this.imovel).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Imóvel salvo com sucesso!"
					});
					this.showCadastroImovel = false;
				},
				(error) => {
					const erros = error.response.data;
					this.erros.push(...erros);

					if (!this.erros.length) {
						this.$root.$emit(
							"alert:error",
							"Houve um problema ao salvar o Imóvel!"
						);
					}
				}
			);
			this.processando(false);
		},
		removerImovel() {
			if (this.imovel && this.imovel.id) {
				this.$parent.processando(true);
				ImovelService.removeImovel(this.imovel.id).then(
					data => {
						console.log(data);
						this.$toast.add({
							severity: "success",
							summary: "Imóvel removido com sucesso"
						});
					},
					error => {
						let errorMessage = "Houve um problema ao remover Imóvel!";
						if (error.response) {
							errorMessage = error.response.data;
						}
						this.$toast.add({
							severity: "error",
							summary: errorMessage
						});
					}
				).then(() => {

					this.$parent.selectedImovel = null;
					this.showRemoverImovel = false;
					this.$parent.processando(false);
				});

			}
		},

		limparForm() {
			this.erros = [];
			this.imovel = new Imovel();
		},

		processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		},

	}, computed: {
		headerDialog() {
			return (
				(this.modoEdicao
					? "Edição de "
					: "Cadastro de ") +
				"Imóvel"
			);
		}
	}
}
</script>

<style scoped>
.scrolable-dialog {
	padding-right: 25px;
	width: 90vw;
	max-height: 65vh;
	overflow-y: auto;
	overflow-x: hidden;
}

.p-inputtext:disabled {
	color: #a6a6a6;
	border-color: #a6a6a6;
}

textarea {
	width: 100%;
	border-radius: 12px;
}
</style>